import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ModalService } from "src/app/service/modal-service";
@Component({
  selector: "app-download-modal",
  templateUrl: "./download-modal.component.html",
  styleUrls: ["./download-modal.component.css"],
})
export class DownloadModalComponent implements OnInit {
  @Input() sFileName: string = "Filename";
  @Input() fWidth: number = 300;
  @ViewChild("fileName") fileName: ElementRef;
  promptTitle = "Export File";

  button1Label = "Save";
  button2Label = "Cancel";

  @Output() downloadEvent = new EventEmitter();

  txFileNameID = String(Math.random() * (13904.4953 - 1039.39402) + 4.9);

  constructor(private modalService: ModalService) {}

  ngOnInit() {}

  openModal() {
    this.modalService.open("download-modal");
    //this.fileName.nativeElement.value = this.sFileName;
  }

  closeModal() {
    this.modalService.close("download-modal");
  }

  buttonClick(fileName) {
    if (fileName.length < 1) {
      this.fileName.nativeElement.style.borderColor = "#E60000";
    } else {
      this.downloadEvent.emit(fileName);
    }
  }

  updateFileName(event: string) {
    this.sFileName = event.toUpperCase();
  }
}
